import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-legal-information',
  imports: [RouterLink],
  templateUrl: './legal-information.html',
  styleUrl: './legal-information.css'
})
export class LegalInformation { }
